import styled from 'styled-components'

import { Input, type InputProps } from '@root/shared/ui-kit'

import type { TypeHelper } from '@blade/std-lib'
import type { ClassNameProps } from '@root/shared/react'

// type InputPercentageValues = {
//   value: string
// }

type Mode = 'percents' | 'number'

type InputPercentageProps = {
  value: string
  mode: Mode
  onChange: (values: string) => void
} & ClassNameProps &
  TypeHelper.OmitKey<InputProps, 'value' | 'onChange'>

export const InstantTradeQuickOptionInput: React.FC<InputPercentageProps> = ({
  value,
  onChange,
  startContent,
  size = 's',
  className,
  mode,
  disabled,
}) => (
  <Root
    $mode={mode}
    disabled={disabled}
    className={className}
    numeric
    decimalScale={mode === 'percents' ? 0 : undefined}
    size={size}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    isAllowed={({ floatValue }) => {
      return (
        floatValue === undefined ||
        (mode === 'percents' ? floatValue <= 100 : true)
      )
    }}
    allowLeadingZeros={false}
    placeholder="0"
    startContent={startContent}
    endContent={mode === 'percents' ? <Percents /> : undefined}
  />
)

const Root = styled(Input)<{ $mode: Mode }>`
  --input-padding-inline: 0px;

  & input {
    font-weight: 700;
    color: ${(x) =>
      x.$mode === 'percents' ? 'var(--downAccent-9)' : 'var(--upAccent-9)'};
    caret-color: currentColor;
    text-align: center;
    font-size: 11px;
  }
`

const Percents = styled.span.attrs({ children: '%' })`
  padding-right: 6px;
`
